export const hasPermissions = (
  requiredPermissions: string[],
  userPermissions: string[]
) => {
  const hasAllPermissions = requiredPermissions.every((action) =>
    userPermissions.includes(action)
  )
  return hasAllPermissions
}
